import { useOrganization } from '@clerk/clerk-react';

import { resellerPartners } from '@/config/current-partner';
import type { ResellerPartnerConfig } from '@/config/reseller-partners';
import { useOrgWhitelabel } from '@/hooks/use-org-whitelabel';

/**
 * Returns the legacy code-only reseller branding for the active org, or null.
 * Prefer `useEffectiveBranding()` for visuals — it merges code + DB layers.
 */
export function useResellerPartner(): ResellerPartnerConfig | null {
  useOrganization();
  const whitelabel = useOrgWhitelabel();
  return whitelabel ? (resellerPartners()[whitelabel] ?? null) : null;
}

/** True when the active org is attributed to any known partner slug. */
export const useHasOrgPartner = (): boolean => !!useOrgWhitelabel();
